(() => {
  const ready = (fn) => {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  };

  ready(() => {
    document.querySelectorAll('[data-gal-open-cart]').forEach((btn) => {
      btn.addEventListener('click', (e) => {
        if (window.Galactica?.settings?.cartType === 'drawer') {
          e.preventDefault();
          document.dispatchEvent(new CustomEvent('gal:cart:open'));
        }
      });
    });

    document.querySelectorAll('[data-gal-menu-toggle]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const menu = document.querySelector('[data-gal-mobile-menu]');
        if (!menu) return;
        const open = menu.hasAttribute('hidden');
        if (open) menu.removeAttribute('hidden');
        else menu.setAttribute('hidden', '');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });

    /* Mega menu — Eden Peak N1→N2 bar→N3 + overlay below header */
    const header = document.querySelector('[data-gal-header]');
    const megaItems = [...(header?.querySelectorAll('[data-gal-mega-item][data-has-panel]') || [])];
    let closeTimer = null;

    const syncHeaderHeight = () => {
      if (!header) return;
      document.documentElement.style.setProperty('--gal-header-h', `${header.offsetHeight}px`);
    };

    /* Sticky collapse: hide utility + shrink logo after scroll */
    const headerSection = header?.closest('.shopify-section');
    const announceSection = document.querySelector('.shopify-section:has(.gal-announce), .gal-announce')?.closest('.shopify-section')
      || document.querySelector('.gal-announce')?.parentElement;
    const syncHeaderCompact = () => {
      if (!header || !header.classList.contains('is-sticky')) return;
      const compact = window.scrollY > 24;
      header.classList.toggle('is-compact', compact);
      headerSection?.classList.toggle('is-compact', compact);
      if (announceSection) {
        announceSection.hidden = compact;
        announceSection.style.display = compact ? 'none' : '';
      }
      syncHeaderHeight();
    };

    syncHeaderHeight();
    syncHeaderCompact();
    window.addEventListener('resize', () => {
      syncHeaderHeight();
      syncHeaderCompact();
    });
    window.addEventListener('scroll', syncHeaderCompact, { passive: true });

    const ensureOverlay = () => {
      let overlay = document.getElementById('GalMegaOverlay');
      if (!overlay) {
        overlay = document.createElement('div');
        overlay.id = 'GalMegaOverlay';
        overlay.setAttribute('aria-hidden', 'true');
        document.body.appendChild(overlay);
      }
      return overlay;
    };

    const overlay = ensureOverlay();

    const setMegaOpenState = (open) => {
      syncHeaderHeight();
      document.body.classList.toggle('gal-mega-open', open);
      overlay.setAttribute('aria-hidden', open ? 'false' : 'true');
      overlay.classList.toggle('is-active', open);
    };

    const closeAllMega = (except = null) => {
      megaItems.forEach((item) => {
        if (item === except) return;
        item.classList.remove('is-open');
        const trigger = item.querySelector('[data-gal-mega-trigger]');
        const panel = item.querySelector('[data-gal-mega-panel]');
        if (trigger) trigger.setAttribute('aria-expanded', 'false');
        if (panel) {
          panel.classList.remove('is-open');
          panel.setAttribute('hidden', '');
        }
      });
      if (!except) setMegaOpenState(false);
    };

    const openMega = (item) => {
      if (!item) return;
      closeAllMega(item);
      item.classList.add('is-open');
      const trigger = item.querySelector('[data-gal-mega-trigger]');
      const panel = item.querySelector('[data-gal-mega-panel]');
      if (trigger) trigger.setAttribute('aria-expanded', 'true');
      if (panel) {
        panel.removeAttribute('hidden');
        panel.classList.add('is-open');
      }
      setMegaOpenState(true);
    };

    const activateSub = (panel, triggerBtn) => {
      if (!panel || !triggerBtn) return;
      const key = triggerBtn.getAttribute('data-sub-trigger');
      panel.querySelectorAll('[data-gal-mega-sub]').forEach((btn) => {
        const on = btn === triggerBtn;
        btn.classList.toggle('is-active', on);
        btn.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      panel.querySelectorAll('[data-gal-mega-detail]').forEach((detail) => {
        const on = detail.getAttribute('data-sub-detail') === key;
        detail.classList.toggle('is-active', on);
        if (on) detail.removeAttribute('hidden');
        else detail.setAttribute('hidden', '');
      });
    };

    overlay.addEventListener('click', () => closeAllMega());

    megaItems.forEach((item) => {
      const trigger = item.querySelector('[data-gal-mega-trigger]');
      const panel = item.querySelector('[data-gal-mega-panel]');
      if (!trigger || !panel) return;

      item.addEventListener('mouseenter', () => {
        clearTimeout(closeTimer);
        openMega(item);
      });
      item.addEventListener('mouseleave', () => {
        closeTimer = setTimeout(() => closeAllMega(), 160);
      });

      trigger.addEventListener('click', (e) => {
        const expanded = trigger.getAttribute('aria-expanded') === 'true';
        const coarse = window.matchMedia('(hover: none)').matches;
        if (coarse && !expanded) {
          e.preventDefault();
          openMega(item);
        }
      });

      trigger.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowDown') {
          e.preventDefault();
          openMega(item);
          panel.querySelector('[data-gal-mega-sub], a, button')?.focus();
        }
        if (e.key === 'Escape') {
          closeAllMega();
          trigger.focus();
        }
      });

      trigger.addEventListener('focus', () => openMega(item));

      panel.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
          closeAllMega();
          trigger.focus();
        }
      });

      panel.addEventListener('mouseenter', () => clearTimeout(closeTimer));
      panel.addEventListener('mouseleave', () => {
        closeTimer = setTimeout(() => closeAllMega(), 160);
      });

      panel.querySelectorAll('[data-gal-mega-sub]').forEach((btn) => {
        btn.addEventListener('mouseenter', () => activateSub(panel, btn));
        btn.addEventListener('focus', () => activateSub(panel, btn));
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          activateSub(panel, btn);
        });
      });
    });

    /* FLEURS CBD cultivation switcher — side-by-side tabs, one shared gallery */
    const activateCult = (root, key) => {
      if (!root) return;
      const k = String(key);
      root.querySelectorAll('[data-gal-cult-tab]').forEach((tab) => {
        const on = tab.getAttribute('data-cult-key') === k;
        tab.classList.toggle('is-active', on);
        tab.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      root.querySelectorAll('[data-gal-cult-pane]').forEach((pane) => {
        const on = pane.getAttribute('data-cult-key') === k;
        pane.classList.toggle('is-active', on);
        if (on) pane.removeAttribute('inert');
        else pane.setAttribute('inert', '');
      });
    };

    document.querySelectorAll('[data-gal-cult-switch]').forEach((root) => {
      const coarse = () => window.matchMedia('(hover: none)').matches;
      root.querySelectorAll('[data-gal-cult-tab]').forEach((tab) => {
        const key = tab.getAttribute('data-cult-key');
        tab.addEventListener('mouseenter', () => {
          if (!coarse()) activateCult(root, key);
        });
        tab.addEventListener('focus', () => activateCult(root, key));
        tab.addEventListener('click', (e) => {
          const already = tab.classList.contains('is-active');
          if (coarse() && !already) {
            e.preventDefault();
            activateCult(root, key);
            return;
          }
          /* Desktop / already-active: allow navigation to collection */
          activateCult(root, key);
        });
      });
      const def = root.querySelector('[data-cult-default]')?.getAttribute('data-cult-key') || '0';
      activateCult(root, def);
    });

    header?.addEventListener('focusout', (e) => {
      if (!header.contains(e.relatedTarget)) closeAllMega();
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') closeAllMega();
    });

    /* Product finder modal */
    const finder = document.querySelector('[data-gal-finder]');
    let finderLastFocus = null;

    const getFocusable = (root) =>
      [...root.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])')].filter(
        (el) => !el.hasAttribute('disabled') && el.offsetParent !== null
      );

    const bindModalChrome = (dialog, { openClass, closeSelector, onOpen, onClose, lastFocusRef }) => {
      if (!dialog) return { open() {}, close() {} };
      let lastFocus = null;
      const open = (trigger) => {
        lastFocus = trigger || document.activeElement;
        if (lastFocusRef) lastFocusRef.current = lastFocus;
        onOpen?.(dialog);
        if (typeof dialog.showModal === 'function') dialog.showModal();
        else dialog.setAttribute('open', '');
        if (openClass) document.body.classList.add(openClass);
        getFocusable(dialog)[0]?.focus({ preventScroll: true });
      };
      const close = () => {
        if (typeof dialog.close === 'function') dialog.close();
        else dialog.removeAttribute('open');
        if (openClass) document.body.classList.remove(openClass);
        onClose?.(dialog);
        (lastFocusRef?.current || lastFocus)?.focus?.({ preventScroll: true });
      };
      dialog.querySelectorAll(closeSelector).forEach((btn) => btn.addEventListener('click', () => close()));
      dialog.addEventListener('cancel', (e) => {
        e.preventDefault();
        close();
      });
      dialog.addEventListener('click', (e) => {
        if (e.target === dialog) close();
      });
      dialog.addEventListener('keydown', (e) => {
        if (e.key !== 'Tab') return;
        const focusables = getFocusable(dialog);
        if (!focusables.length) return;
        const first = focusables[0];
        const last = focusables[focusables.length - 1];
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      });
      return { open, close };
    };

    const finderFocus = { current: null };
    const finderUi = bindModalChrome(finder, {
      openClass: 'gal-finder-open',
      closeSelector: '[data-gal-finder-close]',
      lastFocusRef: finderFocus,
      onOpen: (dialog) => dialog.querySelector('[data-gal-finder-engine]')?.reset?.(),
    });
    const openFinder = (trigger) => finderUi.open(trigger);
    const closeFinder = () => finderUi.close();

    document.querySelectorAll('[data-gal-open-finder]').forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        openFinder(btn);
      });
    });

    /* Pack Frère modal */
    const packDialog = document.querySelector('[data-gal-pack]');
    const packFocus = { current: null };
    const startPackEngine = (dialog) => {
      const engine = dialog?.querySelector('gal-pack-builder');
      const run = () => engine?.openWithMeter?.();
      if (engine?.openWithMeter) run();
      else customElements.whenDefined('gal-pack-builder').then(run);
    };

    const packUi = bindModalChrome(packDialog, {
      openClass: 'gal-pack-open',
      closeSelector: '[data-gal-pack-close]',
      lastFocusRef: packFocus,
      onOpen: startPackEngine,
    });

    document.querySelectorAll('[data-gal-open-pack]').forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        packUi.open(btn);
      });
    });

    const autoPack =
      window.location.hash === '#pack-frere' ||
      window.location.search.includes('pack=frere') ||
      /\/products\/cree-ton-pack-frere\/?$/.test(window.location.pathname);
    if (autoPack) requestAnimationFrame(() => packUi.open());

    /* Mobile accordion — sibling-scoped so nested FLEURS groups stay open under parent */
    document.querySelectorAll('[data-gal-accordion-toggle]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const item = btn.closest('[data-gal-accordion-item]');
        const panelId = btn.getAttribute('aria-controls');
        const panel = panelId ? document.getElementById(panelId) : item?.querySelector('[data-gal-accordion-panel]');
        if (!item || !panel) return;
        const open = panel.hasAttribute('hidden');

        const siblingItems = [...(item.parentElement?.children || [])].filter(
          (el) => el.matches?.('[data-gal-accordion-item]')
        );
        siblingItems.forEach((sib) => {
          if (sib === item) return;
          const sibRow = [...sib.children].find((el) => el.classList?.contains('gal-mobile-nav__row'));
          const sibToggle = sibRow?.querySelector('[data-gal-accordion-toggle]');
          const sibPanelId = sibToggle?.getAttribute('aria-controls');
          const sibPanel = sibPanelId ? document.getElementById(sibPanelId) : null;
          if (sibPanel) sibPanel.setAttribute('hidden', '');
          if (sibToggle) {
            sibToggle.setAttribute('aria-expanded', 'false');
            const icon = sibToggle.querySelector('[aria-hidden="true"]');
            if (icon) icon.textContent = '+';
          }
        });

        if (open) {
          panel.removeAttribute('hidden');
          btn.setAttribute('aria-expanded', 'true');
          const icon = btn.querySelector('[aria-hidden="true"]');
          if (icon) icon.textContent = '−';
        } else {
          panel.setAttribute('hidden', '');
          btn.setAttribute('aria-expanded', 'false');
          const icon = btn.querySelector('[aria-hidden="true"]');
          if (icon) icon.textContent = '+';
        }
      });
    });

    /* Analog needle meter — shared premium loading language */
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const setNeedleAngle = (root, deg) => {
      const arm = root?.querySelector('[data-gal-needle-arm]');
      if (!arm) return;
      arm.setAttribute('transform', `rotate(${deg} 80 72)`);
    };

    const playNeedleMeter = (root, { duration = 1100 } = {}) =>
      new Promise((resolve) => {
        if (!root) {
          resolve();
          return;
        }
        const needle = root.matches?.('[data-gal-needle]') ? root : root.querySelector('[data-gal-needle]');
        if (!needle) {
          resolve();
          return;
        }
        needle.classList.add('is-active');
        setNeedleAngle(needle, -58);

        if (reducedMotion) {
          setNeedleAngle(needle, 58);
          window.setTimeout(() => {
            needle.classList.remove('is-active');
            resolve();
          }, 180);
          return;
        }

        const start = performance.now();
        const jitterUntil = duration * 0.55;
        const peakAt = duration * 0.88;

        const tick = (now) => {
          const t = now - start;
          if (t >= duration) {
            setNeedleAngle(needle, 62);
            needle.classList.add('is-peaked');
            window.setTimeout(() => {
              needle.classList.remove('is-active', 'is-peaked');
              setNeedleAngle(needle, -52);
              resolve();
            }, 90);
            return;
          }
          if (t < jitterUntil) {
            const wobble = Math.sin(t / 55) * 10 + (Math.random() * 14 - 7);
            setNeedleAngle(needle, -28 + wobble);
          } else if (t < peakAt) {
            const p = (t - jitterUntil) / (peakAt - jitterUntil);
            setNeedleAngle(needle, -20 + p * 70);
          } else {
            setNeedleAngle(needle, 64);
            needle.classList.add('is-peaked');
          }
          requestAnimationFrame(tick);
        };
        requestAnimationFrame(tick);
      });

    window.Galactica = window.Galactica || {};
    window.Galactica.playNeedleMeter = playNeedleMeter;

    /* PDP description normalization — editorial text only GAL_DESC_NORM_V5 */
    const TECH_LINE =
      /^(?:\s*(?:cbd|thc|cbg|cbc|cbn|thcp|hhc)\s*[:：])|(?:\b\d+(?:[.,]\d+)?\s*%\s*(?:cbd|thc|cbg|cbc|cbn)\b)|(?:^\s*\d+\s*g(?:ramme?s?)?\s*$)|(?:^\s*(?:10|25|50|100)\s*g\b)|(?:^\s*format[s]?\s*[:：])|(?:^\s*(?:usage|type\s+de\s+culture|densité|taille\s+des\s+têtes|arômes?|saveur)\s*[:：])/i;
    const TECH_INLINE =
      /\b(?:cbd|thc|cbg|cbc|cbn)\s*[:：]\s*(?:entre\s+)?[<>]?\s*\d+(?:[.,]\d+)?\s*%(?:\s*(?:à|et|-|suivant)[^.]*)?|\b(?:cbd|thc|cbg|cbc|cbn)\s*[:：]\s*inférieur(?:e)?\s+à\s*\d+(?:[.,]\d+)?\s*%[^.]*(?:\.|$)?|\b(?:cbd|thc|cbg|cbc|cbn)\s*[:：]?\s*[<>]?\s*\d+(?:[.,]\d+)?\s*%|\b\d+(?:[.,]\d+)?\s*%\s*(?:de\s+)?(?:cbd|thc|cbg|cbc|cbn)\b|\btaux\s+de\s+(?:cbd|thc|cbg|cbc|cbn)\b[^.]{0,80}\d+(?:[.,]\d+)?\s*%(?:\s*(?:à|et|-)\s*\d+(?:[.,]\d+)?\s*%)?|\b(?:cbd|thc|cbg|cbc|cbn)\b[^.]{0,50}entre\s+\d+(?:[.,]\d+)?\s*%\s*et\s*\d+(?:[.,]\d+)?\s*%|\binférieur(?:e)?\s+à\s*\d+(?:[.,]\d+)?\s*%\b[^.]{0,80}(?:législation|européenne)?|\bhaute\s+teneur\s+en\s+(?:cbd|thc|cbg|cbc|cbn)\b|\b(?:10|25|50|100)\s*g(?:ramme?s?)?\b/gi;
    const WELLNESS =
      /\b(?:relaxant(?:e|s)?|relaxation|anti[-\s]?stress|anxiété|anxiety|sommeil|endormissement|douleur(?:s)?|anti[-\s]?douleur|bienfaits?|thérapeutique|thérapie|médical(?:e)?|pharmaceutique|sleep|pain\s*relief|détente(?:\s+profonde)?|bien[-\s]?être(?:\s+intense)?|apaiser(?:\s+l['’]esprit)?|effets?\s+idéaux)\b/gi;
    const NOISE_LINE =
      /^(?:✅|🌿|✨|⭐|★)|(?:en\s+résumé)|(?:produit\s+non\s+destiné)|(?:usage\s*:)|(?:fleur\s+indoor\s*:)|(?:explorez\s+notre\s+sélection)|(?:ces\s+bocaux\s+sont\s+ensuite)|(?:fleurs?\s+de\s+chanvre\s+conditionnées)|(?:^saveur\b)|(?:^arômes?\b)|(?:^caractéristiques\b)|(?:^goût\b)|(?:^couleur\b)|(?:^texture\b\s)/i;
    const SPEC_BLOB =
      /(?:✅\s*)?en\s+résumé[\s\S]*$|\bcaractéristiques\b[\s\S]*$|\b(?:arômes?\s+naturels?|densité|taille\s+des\s+têtes|type\s+de\s+culture|couleur|goût)\s*[:：–-]?[\s\S]*$/i;

    const stripAttrs = (el) => {
      [...el.querySelectorAll('*')].forEach((node) => {
        node.removeAttribute('style');
        node.removeAttribute('color');
        node.removeAttribute('face');
        node.removeAttribute('size');
        node.removeAttribute('align');
        if (node.tagName === 'FONT') {
          const parent = node.parentNode;
          while (node.firstChild) parent.insertBefore(node.firstChild, node);
          parent.removeChild(node);
        }
      });
      [...el.querySelectorAll('u')].forEach((u) => {
        const parent = u.parentNode;
        while (u.firstChild) parent.insertBefore(u.firstChild, u);
        parent.removeChild(u);
      });
      [...el.querySelectorAll('br')].forEach((br) => {
        br.replaceWith(document.createTextNode(' '));
      });
    };

    const finalizeEditorial = (text) => {
      const parts = String(text || '')
        .split(/(?<=[.!?])\s+/)
        .map((s) => s.trim())
        .filter(Boolean);
      const kept = parts.filter((sentence) => {
        if (sentence.length < 18) return false;
        if (/\b(?:et|ou|ses|des|une|un|de|du|la|le|les|à|aux|pour|avec|sans|en|elle|il|ils|elles)\s*[.!?]?$/i.test(sentence)) {
          return false;
        }
        if (!/[.!?]$/.test(sentence) && sentence.length < 90) return false;
        return true;
      });
      return kept.join(' ').replace(/\s{2,}/g, ' ').trim();
    };

    const repairEditorial = (text) => {
      let out = text
        .replace(/\bidéale\s+pour\s+un\s+moment\s+de\b[^.]*\.?/gi, '.')
        .replace(/\bpour\s+un\s+moment\s+de\s*\.?/gi, '.')
        .replace(/\b(?:et\s+)?sa\s*\./gi, '.')
        .replace(/\bavec\s+un\s*,/gi, ',')
        .replace(/\bune?\s+résine\s+premium\s+à\s*,/gi, 'une résine premium,')
        .replace(/\boffre\s+une\s*,/gi, '')
        .replace(/\boffre\s+une\s*\./gi, '.')
        .replace(/,?\s*elle\s+offre(?:\s+une)?\s*[,.]?/gi, '.')
        .replace(/\belle\s*\./gi, '.')
        .replace(/\bsaveur\s+[a-zéèêëàâäùûüîïôöœ'\-\s]+$/gi, '')
        .replace(/\boffre\s+une\s+expérience[^.]{0,40}pour\s+la\s+et\s+la\s*\./gi, '.')
        .replace(/\bpour\s+la\s+et\s+la\s*\./gi, '.')
        .replace(/\bune?\s+alliée\s+de\s+choix\s+pour\s+la\s+et\s+la\s*\./gi, '.')
        .replace(/\ben\s+fait\s+une\s+alliée\s+de\s+choix[^.]{0,40}\./gi, '.')
        .replace(/\bsa\s+concentration\s+élevée\s+en\s+cannabidiol\s*\.?/gi, '')
        .replace(/\babsence\s+totale\s+de\s+thc\b[^.]{0,100}/gi, '')
        .replace(/\bgrâce\s+à\s+sa\s+haute\s+teneur\b[^.!]*/gi, '')
        .replace(/\bpour\s+garantir\s+une\s*\.?$/gi, '.')
        .replace(/\bprofitez\s+des\s+qu['’]elle\b[^.!]*/gi, '')
        .replace(/\blaissez[-\s]vous\s+séduire\b[^.!]*/gi, '')
        .replace(/\bà\s+la\s+recherche\s+d['’']une\s+expérience\s+ou\b/gi, "à la recherche d'un produit")
        .replace(/\belle\s+procure\s+également[^.]{0,120}\./gi, '.')
        .replace(/\bn['’]est\s+pas\s+seulement\s+délicieuse,?\s*/gi, '')
        .replace(/\bla\s+california\s+indoor\s*\./gi, '')
        .replace(/\ben\s+somme,?\s*la\s*$/gi, '')
        .replace(/\ben\s+somme,?\s*/gi, '')
        .replace(/\bl['’]expérience\s+[a-zéèêëàâäùûüîïôöœ'\-\s]+$/gi, '')
        .replace(/\bcouleur\b[^.!]*/gi, '')
        .replace(/\s*,\s*,+/g, ',')
        .replace(/\s{2,}/g, ' ')
        .replace(/\s+([,.;:!?])/g, '$1')
        .replace(/,\s*\./g, '.')
        .replace(/\.\s*,/g, '.')
        .replace(/\(\s*\)/g, '')
        .replace(/\bà\s*,/gi, ',')
        .replace(/\s*\.\s*\./g, '.')
        .replace(/\s{2,}/g, ' ')
        .replace(/([.!?])([A-ZÀÂÄÇÉÈÊËÎÏÔÖÙÛÜŒ])/g, '$1 $2')
        .replace(/^\s*[,.;:]\s*/g, '')
        .replace(/\b(?:une|un|des|de|du|la|le|les|et|ou|pour|avec|sans|en|elle|qu['’]elle)\s*$/gi, '')
        .trim();
      out = out.replace(/[,:;]\s*$/g, '.').replace(/\.\s*$/g, '.').trim();
      out = out.replace(/,?\s*elle\s+offre\.?$/gi, '.').replace(/\s*\.\s*\./g, '.').trim();
      return finalizeEditorial(out);
    };

    const cleanEditorialText = (raw) => {
      let text = String(raw || '')
        .replace(/[\u{1F300}-\u{1FAFF}\u{2600}-\u{27BF}]/gu, ' ')
        .replace(/\s+/g, ' ')
        .trim();
      if (!text) return '';
      if (NOISE_LINE.test(text)) return '';
      if (TECH_LINE.test(text) && (text.length < 140 || /(?:cbd|thc|cbg|cbc|cbn)\s*[:：]/i.test(text))) return '';
      text = text.replace(SPEC_BLOB, '');
      text = text.replace(TECH_INLINE, '');
      text = text.replace(WELLNESS, '');
      text = repairEditorial(text);
      if (!text || text.length < 12) return '';
      if (TECH_LINE.test(text) || /(?:cbd|thc)\s*[:：]/i.test(text)) return '';
      if (/\d+(?:[.,]\d+)?\s*%/.test(text) && /(?:cbd|thc|cbg|cbc|cbn)/i.test(text)) return '';
      return text;
    };

    const normalizeDescription = (body) => {
      if (!body || body.dataset.galDescNormalized === '1') return;
      stripAttrs(body);

      const blocks = [...body.querySelectorAll('p, li, h1, h2, h3, h4, div')];
      const kept = [];
      let stop = false;
      blocks.forEach((block) => {
        if (stop) return;
        if (block.querySelector('p, li, h1, h2, h3, h4')) return;
        const raw = (block.textContent || '').replace(/\s+/g, ' ').trim();
        if (/en\s+résumé/i.test(raw) || /^✅/.test(raw)) {
          stop = true;
          return;
        }
        const text = cleanEditorialText(raw);
        if (!text || text.length < 2) return;
        kept.push(text);
      });

      if (!kept.length) {
        const fallback = cleanEditorialText(body.textContent || '');
        body.innerHTML = fallback ? `<p>${fallback}</p>` : '';
      } else {
        const paragraphs = [];
        let buf = '';
        kept.forEach((chunk) => {
          if (chunk.length < 40 && buf) {
            buf = `${buf} ${chunk}`.trim();
            return;
          }
          if (buf) paragraphs.push(buf);
          buf = chunk;
        });
        if (buf) paragraphs.push(buf);
        body.innerHTML = paragraphs.map((s) => `<p>${s}</p>`).join('');
      }

      body.dataset.galDescNormalized = '1';
    };

    /* PDP info panel tabs + Lire la suite */
    document.querySelectorAll('[data-gal-info-panel]').forEach((panel) => {
      const tabs = [...panel.querySelectorAll('[data-gal-info-tab]')];
      const panes = [...panel.querySelectorAll('[data-gal-info-pane]')];
      tabs.forEach((tab) => {
        tab.addEventListener('click', () => {
          const key = tab.dataset.galInfoTab;
          tabs.forEach((t) => {
            const on = t === tab;
            t.classList.toggle('is-active', on);
            t.setAttribute('aria-selected', on ? 'true' : 'false');
          });
          panes.forEach((pane) => {
            const on = pane.dataset.galInfoPane === key;
            pane.classList.toggle('is-active', on);
            if (on) pane.removeAttribute('hidden');
            else pane.setAttribute('hidden', '');
          });
        });
      });

      const root = panel.querySelector('[data-gal-desc-root]');
      if (!root) return;
      const body = root.querySelector('[data-gal-desc-body]');
      const fade = root.querySelector('[data-gal-desc-fade]');
      const meter = root.querySelector('[data-gal-desc-meter]');
      const toggle = root.querySelector('[data-gal-desc-toggle]');
      if (!body || !toggle) return;

      normalizeDescription(body);

      // Init collapsed only when content overflows a preview height
      body.classList.add('is-collapsed');
      const overflows = body.scrollHeight > body.clientHeight + 8;
      if (!overflows) {
        body.classList.remove('is-collapsed');
        fade?.setAttribute('hidden', '');
        toggle.hidden = true;
        return;
      }
      fade?.removeAttribute('hidden');
      toggle.hidden = false;
      toggle.textContent = 'Lire la suite';

      let busy = false;
      toggle.addEventListener('click', async () => {
        if (busy) return;
        const expanded = !body.classList.contains('is-collapsed');
        if (expanded) {
          body.classList.add('is-collapsed');
          fade?.removeAttribute('hidden');
          toggle.textContent = 'Lire la suite';
          return;
        }
        busy = true;
        toggle.disabled = true;
        if (meter) {
          meter.hidden = false;
          meter.classList.add('is-visible');
        }
        await playNeedleMeter(meter, { duration: 900 });
        body.classList.remove('is-collapsed');
        fade?.setAttribute('hidden', '');
        if (meter) {
          meter.classList.remove('is-visible');
          meter.hidden = true;
        }
        toggle.textContent = 'Réduire';
        toggle.disabled = false;
        busy = false;
      });
    });

    /*
      SAG density: widen iframe viewport so provider Splide hits higher
      perPage (5 / 4 / 3 / 2), then scale to shell. Mobile stays native.
    */
    const sagDesignWidth = (shellW) => {
      /* Slightly above each Splide max-width breakpoint for target density */
      if (shellW >= 1360) return 1860; /* >1857 → 5 cards */
      if (shellW >= 1160) return 1560; /* >1551 → 4 */
      if (shellW >= 940) return 1250; /* >1242 → 3 */
      if (shellW >= 720) return 1000; /* >980 → 2 */
      return shellW; /* native mobile layout ≤750 */
    };

    const fitSagShell = (root, { allowReload = true } = {}) => {
      const shell = root.querySelector('[data-gal-sag-shell]');
      const scaler = root.querySelector('[data-gal-sag-scaler]');
      const frame = root.querySelector('[data-gal-sag-frame]');
      if (!shell || !scaler || !frame) return;

      const shellW = Math.max(1, Math.round(shell.clientWidth));
      const designW = sagDesignWidth(shellW);
      const scale = shellW / designW;
      const baseH = 221;
      const prevDesign = Number(frame.dataset.galSagDesign || 0);

      root.style.setProperty('--gal-sag-scale', String(scale));
      root.style.setProperty('--gal-sag-base-h', `${baseH}px`);
      shell.style.height = `${Math.round(baseH * scale)}px`;
      scaler.style.width = `${designW}px`;
      frame.style.width = `${designW}px`;
      frame.setAttribute('width', String(designW));
      frame.setAttribute('height', String(baseH));

      /*
        Splide mounts against the iframe viewport. When the density bucket
        changes, reload so perPage matches the new design width.
      */
      if (allowReload && prevDesign && prevDesign !== designW) {
        frame.dataset.galSagDesign = String(designW);
        const src = frame.getAttribute('src');
        if (src) frame.setAttribute('src', src);
        return;
      }
      frame.dataset.galSagDesign = String(designW);
    };

    const sagRoots = [...document.querySelectorAll('[data-gal-sag]')];
    const fitAllSag = () => sagRoots.forEach((root) => fitSagShell(root));
    /* Fit before first paint of iframe content when possible */
    fitAllSag();
    window.addEventListener('resize', fitAllSag, { passive: true });
    if (typeof ResizeObserver !== 'undefined') {
      sagRoots.forEach((root) => {
        const shell = root.querySelector('[data-gal-sag-shell]');
        if (!shell) return;
        const ro = new ResizeObserver(() => fitSagShell(root));
        ro.observe(shell);
      });
    }
    sagRoots.forEach((root) => {
      const frame = root.querySelector('[data-gal-sag-frame]');
      if (!frame) return;
      frame.addEventListener('load', () => fitSagShell(root, { allowReload: false }));
    });

    /* ---------- Horizontal VU meters: viewport fill animation ---------- */
    const VU_DURATION = 1350;
    const VU_STAGGER = 60;
    const VU_STAGGER_MAX = 360;
    const VU_SECOND_DELAY = 100;
    const VU_STEREO_OFFSET = 80; /* R lag during anim only (60–100ms) */
    const VU_PEAK_MS = 150;
    /* Smooth ease-out ≈ cubic-bezier(.22,.61,.36,1) */
    const vuEase = (t) => 1 - Math.pow(1 - t, 2.6);

    const reduceVuMotion = () =>
      window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const channelSegs = (channel) => [
      ...channel.querySelectorAll('.gal-vu__segments > .gal-vu__seg'),
    ];

    const applyChannelCount = (channel, count) => {
      const segs = channelSegs(channel);
      segs.forEach((seg, i) => {
        seg.classList.toggle('is-on', i < count);
        seg.classList.remove('is-peak');
      });
      return segs;
    };

    const settleVu = (vu) => {
      const on = Math.max(0, Math.min(12, parseInt(vu.dataset.galVuOn || '0', 10) || 0));
      const channels = [...vu.querySelectorAll('[data-gal-vu-ch]')];
      if (channels.length) {
        /* Hard sync: L and R always identical at rest */
        channels.forEach((ch) => {
          const segs = applyChannelCount(ch, on);
          const last = segs[on - 1];
          if (last) {
            last.classList.add('is-peak');
            window.setTimeout(() => last.classList.remove('is-peak'), VU_PEAK_MS);
          }
        });
      } else {
        const segs = [...vu.querySelectorAll('.gal-vu__segments > .gal-vu__seg')];
        segs.forEach((seg, i) => {
          seg.classList.toggle('is-on', i < on);
          seg.classList.remove('is-peak');
        });
      }
      vu.classList.add('is-played');
      delete vu.dataset.galVuAnimating;
    };

    const animateVu = (vu, startDelay = 0) => {
      if (!vu || vu.dataset.galVuAnimating === '1' || vu.classList.contains('is-played')) return;
      const on = Math.max(0, Math.min(12, parseInt(vu.dataset.galVuOn || '0', 10) || 0));
      const channels = [...vu.querySelectorAll('[data-gal-vu-ch]')];
      const monoSegs = channels.length
        ? []
        : [...vu.querySelectorAll('.gal-vu__segments > .gal-vu__seg')];

      if ((!channels.length && !monoSegs.length) || on <= 0) {
        vu.classList.add('is-played');
        return;
      }

      if (reduceVuMotion()) {
        settleVu(vu);
        return;
      }

      vu.dataset.galVuAnimating = '1';

      const run = () => {
        if (channels.length >= 2) {
          /* One clock drives both channels — only R's progress is delayed */
          applyChannelCount(channels[0], 0);
          applyChannelCount(channels[1], 0);
          const t0 = performance.now();
          const tick = (now) => {
            const elapsed = now - t0;
            const tL = Math.min(1, elapsed / VU_DURATION);
            const tR = Math.min(1, Math.max(0, (elapsed - VU_STEREO_OFFSET) / VU_DURATION));
            applyChannelCount(channels[0], Math.round(vuEase(tL) * on));
            applyChannelCount(channels[1], Math.round(vuEase(tR) * on));
            if (tL < 1 || tR < 1) {
              requestAnimationFrame(tick);
              return;
            }
            /* Final hard lock: L === R === target */
            settleVu(vu);
          };
          requestAnimationFrame(tick);
          return;
        }

        /* Mono / legacy single meter */
        const segs = channels[0] ? channelSegs(channels[0]) : monoSegs;
        segs.forEach((seg) => seg.classList.remove('is-on', 'is-peak'));
        const t0 = performance.now();
        const tick = (now) => {
          const t = Math.min(1, (now - t0) / VU_DURATION);
          const count = Math.round(vuEase(t) * on);
          segs.forEach((seg, i) => seg.classList.toggle('is-on', i < count));
          if (t < 1) {
            requestAnimationFrame(tick);
            return;
          }
          settleVu(vu);
        };
        requestAnimationFrame(tick);
      };

      if (startDelay > 0) window.setTimeout(run, startDelay);
      else run();
    };

    let vuStaggerSlot = 0;
    let vuObserver = null;

    const playVuStack = (stack) => {
      if (!stack || stack.dataset.galVuPlayed === '1') return;
      stack.dataset.galVuPlayed = '1';
      const base = Math.min(vuStaggerSlot * VU_STAGGER, VU_STAGGER_MAX);
      vuStaggerSlot += 1;
      if (vuStaggerSlot > Math.ceil(VU_STAGGER_MAX / VU_STAGGER) + 2) vuStaggerSlot = 0;

      if (stack.matches?.('.gal-vu')) {
        animateVu(stack, base);
        return;
      }

      const meters = [...stack.querySelectorAll('.gal-vu[data-gal-vu-on]')];
      meters.forEach((vu, i) => {
        const delay = base + (i > 0 ? VU_SECOND_DELAY * i : 0);
        animateVu(vu, delay);
      });
    };

    const collectVuUnits = (root = document) => {
      const stacks = [...root.querySelectorAll('[data-gal-vu-stack], [data-gal-gauges]')].filter(
        (el) => el.dataset.galVuPlayed !== '1' && el.querySelector('.gal-vu[data-gal-vu-on]')
      );
      const orphans = [...root.querySelectorAll('.gal-vu[data-gal-vu-on]')].filter(
        (vu) =>
          !vu.closest('[data-gal-vu-stack], [data-gal-gauges]') &&
          vu.dataset.galVuPlayed !== '1' &&
          !vu.classList.contains('is-played')
      );
      return [...stacks, ...orphans];
    };

    const observeVuStacks = (root = document) => {
      const stacks = collectVuUnits(root);
      if (!stacks.length) return;

      if (reduceVuMotion()) {
        stacks.forEach((stack) => {
          stack.dataset.galVuPlayed = '1';
          if (stack.matches?.('.gal-vu')) settleVu(stack);
          else stack.querySelectorAll('.gal-vu[data-gal-vu-on]').forEach(settleVu);
        });
        return;
      }

      if (typeof IntersectionObserver === 'undefined') {
        stacks.forEach((stack, i) => {
          window.setTimeout(() => playVuStack(stack), Math.min(i * VU_STAGGER, VU_STAGGER_MAX));
        });
        return;
      }

      if (!vuObserver) {
        vuObserver = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;
              playVuStack(entry.target);
              vuObserver.unobserve(entry.target);
            });
          },
          { root: null, rootMargin: '80px 0px 80px 0px', threshold: 0.01 }
        );
      }

      stacks.forEach((stack) => {
        vuObserver.observe(stack);
        /* Above-fold / headless fallback — don't rely only on IO */
        const rect = stack.getBoundingClientRect();
        const vh = window.innerHeight || document.documentElement.clientHeight || 0;
        if (rect.top < vh + 80 && rect.bottom > -80 && stack.dataset.galVuPlayed !== '1') {
          playVuStack(stack);
          vuObserver.unobserve(stack);
        }
      });
    };

    window.Galactica = window.Galactica || {};
    window.Galactica.initVuMeters = (root) => observeVuStacks(root || document);

    observeVuStacks(document);

    document.addEventListener('shopify:section:load', (e) => {
      observeVuStacks(e.target || document);
      initTrustStripVu(e.target || document);
    });
    document.addEventListener('shopify:section:reorder', () => {
      observeVuStacks(document);
      initTrustStripVu(document);
    });

    /* Continuous decorative VU — trust strip only (music-like attack/decay) */
    const trustVuState = new WeakMap();
    let trustVuRaf = 0;
    let trustVuRunning = false;

    const rand = (a, b) => a + Math.random() * (b - a);

    const paintTrustCol = (col, level01) => {
      const segs = col.querySelectorAll('.gal-trust-strip__vu-seg');
      if (!segs.length) return;
      const lit = Math.max(0, Math.min(segs.length, Math.round(level01 * segs.length)));
      segs.forEach((seg, i) => {
        /* column-reverse: nth DOM child 0 is bottom visually when flex-direction column-reverse
           In column-reverse, first DOM element appears at bottom. nth-child(1) = bottom.
           Our heat scale nth-child(1)=yellow ... nth-child(10)=red. Light first N in DOM order. */
        seg.classList.toggle('is-on', i < lit);
      });
    };

    const stepTrustVu = (now) => {
      if (!trustVuRunning) return;
      document.querySelectorAll('[data-gal-trust-strip]').forEach((strip) => {
        let st = trustVuState.get(strip);
        if (!st) return;
        if (st.reduced) return;
        st.cols.forEach((ch) => {
          if (now >= ch.nextRetarget) {
            /* Occasional punchy peaks into orange/red, mostly mid yellow/amber */
            const roll = Math.random();
            if (roll < 0.1) ch.target = rand(0.82, 1);
            else if (roll < 0.22) ch.target = rand(0.62, 0.8);
            else if (roll < 0.55) ch.target = rand(0.38, 0.68);
            else ch.target = rand(0.14, 0.4);
            ch.nextRetarget = now + rand(70, 480);
            ch.attack = rand(0.32, 0.62);
            ch.decay = rand(0.06, 0.15);
          }
          const rising = ch.target > ch.level;
          const k = rising ? ch.attack : ch.decay;
          ch.level += (ch.target - ch.level) * k;
          if (Math.abs(ch.target - ch.level) < 0.004) ch.level = ch.target;
          paintTrustCol(ch.el, ch.level);
        });
      });
      trustVuRaf = window.requestAnimationFrame(stepTrustVu);
    };

    const startTrustVuLoop = () => {
      if (trustVuRunning) return;
      trustVuRunning = true;
      trustVuRaf = window.requestAnimationFrame(stepTrustVu);
    };

    const stopTrustVuLoopIfIdle = () => {
      const any = document.querySelector('[data-gal-trust-strip]');
      if (any) return;
      trustVuRunning = false;
      if (trustVuRaf) window.cancelAnimationFrame(trustVuRaf);
      trustVuRaf = 0;
    };

    const initTrustStripVu = (root) => {
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      (root.querySelectorAll ? root.querySelectorAll('[data-gal-trust-strip]') : []).forEach((strip) => {
        if (trustVuState.has(strip)) return;
        const cols = [...strip.querySelectorAll('[data-gal-trust-vu-col]')].map((el, i) => ({
          el,
          level: rand(0.22, 0.45),
          target: rand(0.25, 0.55),
          nextRetarget: performance.now() + rand(40, 220) + i * 30,
          attack: rand(0.3, 0.5),
          decay: rand(0.1, 0.16),
        }));
        trustVuState.set(strip, { cols, reduced });
        cols.forEach((ch) => paintTrustCol(ch.el, reduced ? 0.4 : ch.level));
      });
      if (!reduced) startTrustVuLoop();
      stopTrustVuLoopIfIdle();
    };

    window.Galactica.initTrustStripVu = (root) => initTrustStripVu(root || document);
    initTrustStripVu(document);

    if (typeof MutationObserver !== 'undefined') {
      const mo = new MutationObserver((mutations) => {
        let needs = false;
        for (const m of mutations) {
          m.addedNodes.forEach((node) => {
            if (!(node instanceof HTMLElement)) return;
            if (
              node.matches?.('[data-gal-vu-stack], [data-gal-gauges], .gal-card, .gal-vu') ||
              node.querySelector?.('[data-gal-vu-stack], [data-gal-gauges], .gal-vu[data-gal-vu-on]')
            ) {
              needs = true;
            }
          });
        }
        if (needs) observeVuStacks(document);
      });
      mo.observe(document.body, { childList: true, subtree: true });
    }
  });
})();
